<div class="rating-container">
    <div class="stars">
        <button *ngFor="let star of [1,2,3,4,5]" type="button" class="star-btn" [class.active]="star <= value" [class.half]="star - 0.5 === value" [title]="getRatingLabel(star)" (click)="setValue(star)" (mouseenter)="hoverValue = star" (mouseleave)="hoverValue = null">
          <svg class="star-icon" viewBox="0 0 24 24">
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
          </svg>
        </button>
    </div>
    <!--<div class="rating-label" *ngIf="showLabel">
        {{ getRatingLabel(value) }}
    </div>-->
    <div class="rating-help" *ngIf="helpText">
        {{ helpText }}
    </div>
</div>